<template>
  <div class="main-table">
    <h3 class="table-note">Choose a category, then click a value.</h3>
    <div class="table-holder">
      <img class="bg-image" src="@/assets/images/table-bg.jpg" alt="image description" aria-hidden="true">
      <table>
        <thead>
          <tr>
            <th v-for="field in fields" :key="field.categoryName" v-html="field.categoryName"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(items, rowIndex) in fields[0].items" :key="items">
            <td v-for="field in fields" :key="field" :class="field.items[rowIndex].isRevealed ? 'active' : ''" @click.stop="openAnswer({categoryID: field.categoryID, scores: field.items[rowIndex].scores}, $event)">
              <span v-html="field.items[rowIndex].answer1" class="table__text"></span>
              <span v-html="field.items[rowIndex].scores" class="table__scores"></span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="text-center">
      <AppButton class="btn-next" @click.prevent="goToStep(4)"><span>end game</span></AppButton>
    </div>
    <div class="logo-row-bottom flex-between">
      <div class="logo-holder">
        <img src="@/assets/images/ymi.png" width="53" height="43" alt="image description">
      </div>
      <div class="logo-holder">
        <img src="@/assets/images/got-milk.png" width="191" height="55" alt="image description">
        <p class="copy">&copy; 2024 California Milk Processor Board</p>
      </div>
    </div>
  </div>
  <transition
  v-on:before-enter="beforeEnter"
  v-on:before-leave="beforeLeave"
  v-on:leave="leave"
  name="scale"
  >
  <AppAnswer v-if="isAnswerActive" />
</transition>
</template>

<script>
  import { gsap } from 'gsap';
  import { mapGetters, mapMutations } from "vuex";

  import AppAnswer from '@/components/Answer'

  export default {
    name: "MainTable",
    components: {
      AppAnswer
    },
    computed: {
      ...mapGetters({
        fields: 'getBlocks',
        isAnswerActive: 'getAnswerState',
        answPos: 'getAnswerPos'
      })
    },
    methods: {
      ...mapMutations({
        showAnswer: 'goToAnswer',
        play: 'play',
        getAnswrObj: 'updateAnswerPos',
        goToStep: 'goToStep',
        stop: 'stop',
        getTableHeight() {
          const tableTop = document.querySelector('.table-note')
          const mainTable = document.querySelector('.main-table table')
          const tableBottom = document.querySelector('.logo-row-bottom')

          mainTable.style.height = `${window.innerHeight - tableTop.clientHeight - tableBottom.clientHeight}px`


        }
      }),
      openAnswer(obj, event) {
        const curBox = event.target;
        const clientRects = curBox.getBoundingClientRect();
        const tempObj = {
          left: clientRects.left,
          top: clientRects.top,
          width: clientRects.width,
          height: clientRects.height
        };

        document.body.classList.add('answer-active');
        this.play('question_reveal');
        this.getAnswrObj(tempObj);
        this.showAnswer(obj);
      },
    // transition callbacks
    beforeEnter: function (el) {
        gsap.fromTo(el, { x: `${this.answPos.left + this.answPos.width / 2}px`, y: `${this.answPos.top + this.answPos.height / 2}px`, scaleX: 0, scaleY: 0 }, { x: 0, y: 0, scaleX: 1, scaleY: 1, duration: 0.5});
      setTimeout(() => {
      }, 300);
    },
    beforeLeave: function (el) {
      gsap.fromTo(el, { x: 0, y: 0, scaleX: 1, scaleY: 1}, { x: `${this.answPos.left + this.answPos.width / 2}px`, y: `${this.answPos.top + this.answPos.height / 2}px`, scaleX: 0, scaleY: 0, duration: 0.35 });
    },
    leave: function (el, done) {
      setTimeout(() => done, 500)
    }
  },
  mounted() {
    setTimeout(() => {
      this.getTableHeight();
      setTimeout(() => window.dispatchEvent(new Event('resize')), 500)
    }, 100);
    window.addEventListener("resize", this.getTableHeight);
  },
  unmounted() {
    window.removeEventListener("resize", this.getTableHeight);
  }
}
</script>
